'use client';

import { ReactNode } from 'react';
import Modal from '@/app/_components/modal';
import Container from '@/app/_components/container';
import { ChevronLeftIcon } from '@heroicons/react/24/solid';

export const ModalSearchContainer = ({
  children,
  onClose,
  isModalOpen,
}: {
  children: ReactNode;
  onClose: () => void;
  isModalOpen: boolean;
}) => {
  if (!isModalOpen) return <>{children}</>;
  return (
    <Modal isModalOpen={true} className={'m-0 h-full max-h-full w-full max-w-full pb-5'} onClose={onClose}>
      <Container>
        <div className="grid grid-cols-[24px_1fr_24px] items-center py-6 text-center">
          <button className="size-8 p-1" onClick={onClose}>
            <ChevronLeftIcon className="cursor-pointer text-primary" />
          </button>
          <span className="text-lg font-medium text-primary">Ricerca</span>
          <div />
        </div>
        <div className="py-4">{children}</div>
      </Container>
    </Modal>
  );
};
